const KEY = "mashriqain:intro-seen";

/** Seconds the opening intro covers the page, when it plays. */
export const INTRO_SECONDS = 2.8;

/**
 * Whether the opening intro plays on this page load: once per browser
 * session, never with reduced motion. Decided once, when the app starts,
 * so every component agrees for the whole visit.
 */
export const introPlays: boolean = (() => {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
  try {
    if (sessionStorage.getItem(KEY)) return false;
    sessionStorage.setItem(KEY, "1");
  } catch {
    // Storage can be blocked; then the intro simply plays on every load.
  }
  return true;
})();

/** How long entrance animations on the first screen should wait for the intro. */
export const introDelay = introPlays ? INTRO_SECONDS - 0.5 : 0;
